export default __webpack_public_path__ + "static/media/ic_arrow_right.e44f19f3.svg";